import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import Loader from './../shared/loader'
import Multiselect from 'vue-multiselect'
import Pagination from './../shared/pagination'
import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs';

export default {
	name: 'uploadCsv',
	components: {
		Loader
	},
	data: function() {
		return {
			file: '',
			error_message: '',
			success_message: '',
			error_seen: false,
			success_seen: false,
			csv_config: [],

			rejectedList: [],
			isLoading: false,
			listDataCsv: [],
			csvFields: [],

			user_type: '',
			useremail: '',
			client: '',
			clientid: '',
			listClientData: [],
			showSelectClient: false,
			ClientErr: '',

			warehouseid: '',
			warehouse: '',
			merchant: '',
			listMerchantData: [],
			showMerchantFilter: false,
			showOtherDetails: true,
		}
	},
	created: function() {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);

		this.user_type = userdetail.utype;
		this.useremail = userdetail.email;

		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.clientid = '';
				this.getClientList();
				break;

			case 'warehouse_user':
				this.showSelectClient = true;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.clientid = '';
				this.getClientList();
				break;

			case 'client_user':
				this.showMerchantFilter = true;
				this.clientid = userdetail.clientid;

				this.getMerchantData(userdetail.clientid);
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},
	methods: {
		getClientList() {
			if (window.localStorage.getItem("clientList") !== null) {
				var clientListEncrypt = window.localStorage.getItem('clientList');
				var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
				var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
				this.listClientData = JSON.parse(plaintextclient);
			} else {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.input = ({
					warehouseid: this.warehouseid,
				});
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(result => {
						this.listClientData = result.data.data;
					}, error => {
						console.error(error);
					});
			}
		},
		clientSelected() {
			this.clientid = this.client;
			this.showMerchantFilter = false;
			this.showOtherDetails = true;
			this.merchant = '';
			this.getMerchantData(this.client);
		},

	 		downloadTemplate() {
	 			this.csvFields = [{
	 					'fieldIndex': 0,
	 					'fieldColumn': 'orderid',
	 					'fieldName':  this.$t('common.orderID')
	 				},
	 				{
	 					'fieldIndex': 1,
	 					'fieldColumn': 'boxid',
	 					'fieldName':  this.$t('common.boxId')
	 				},
	 				{
	 					'fieldIndex': 2,
	 					'fieldColumn': 'Product ID',
	 					'fieldName': this.$t('common.productId')
	 				}
	 			]
	 			let test = []
	 			var dateFilder = [];
	 			var skipFilter = [];
	 			this.jsonToCSV('UploadCsv', [], this.csvFields, dateFilder, skipFilter);
	 		},
	 		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
	 	 	 var csvData = ''
	 	 	 if (this.title != null) {
	 	 		 csvData += this.parseExtraData(this.title, '${data}\r\n')
	 	 	 }
	 	 	 csvfield.forEach(function(fields) {
	 	 		 if (skipFilter.indexOf(fields.fieldColumn) == -1) {
	 	 			 csvData += fields.fieldName + ','
	 	 		 }
	 	 	 });
	 	 	 csvData = csvData.slice(0, csvData.length - 1)
	 	 	 csvData += '\r\n'
	 	 	 data.map(function(item) {
	 	 		 var i = 0;
	 	 		 var escapedCSV = ''
	 	 		 for (let key in item) {
	 	 			 if (skipFilter.indexOf(key) == -1) {
	 	 				 escapedCSV = item[key] + '' // cast Numbers to string
	 	 				 if (escapedCSV.match(/[,"\n]/)) {
	 	 					 escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
	 	 				 }
	 	 				 if (escapedCSV == 'null')
	 	 					 csvData += ',';
	 	 				 else {
	 	 					 if (dateFilder.indexOf(key) != -1)
	 	 						 csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ','
	 	 					 else
	 	 						 csvData += escapedCSV + ','
	 	 				 }
	 	 			 }
	 	 			 i++;
	 	 		 }
	 	 		 csvData = csvData.slice(0, csvData.length - 1)
	 	 		 csvData += '\r\n'
	 	 	 })
	 	 	 if (this.footer != null) {
	 	 		 csvData += this.parseExtraData(this.footer, '${data}\r\n')
	 	 	 }
	 	 	 filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
	 	 	 return this.export(csvData, filename, "application/csv");
	 	 	 return csvData
	 	 },
	 	 export (data, filename, mime) {
	 		 let blob = this.base64ToBlob(data, mime)
	 		 download(blob, filename, mime)
	 	 },

	 	 base64ToBlob(data, mime) {
	 		 let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
	 		 let bstr = atob(base64)
	 		 let n = bstr.length
	 		 let u8arr = new Uint8ClampedArray(n)
	 		 while (n--) {
	 			 u8arr[n] = bstr.charCodeAt(n)
	 		 }
	 		 return new Blob([u8arr], {
	 			 type: mime
	 		 })
	 	 },
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
		},
		submitFile() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if (this.file == '' || (this.$refs.file.files[0].type != 'text/csv' && this.$refs.file.files[0].type != 'application/vnd.ms-excel')) {
				let uploadFileExtension = this.$refs.file.files[0];
				if (/\.(csv|ms-excel|CSV)$/i.test(uploadFileExtension.name)) {
					//do nothing
					console.log(uploadFileExtension.name, "=====================Valid Extension====================");
				} else {
					this.$alertify.error("Please select csv file!");
					return false;
					console.log(uploadFileExtension.name, "=====================InValid Extension====================");
				}
			}
			this.isLoading = true;
			if (document.getElementById('downloadBtn'))
				document.getElementById('downloadBtn').disabled = false;
			var formData = new FormData();
			formData.append('csv', this.file);
			//console.log(this.file)
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/uploadCsv/uploadCsv.component.js